/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaborators1Inputs */

const en_settings_collaborators_invitecollaborators1 = /** @type {(inputs: Settings_Collaborators_Invitecollaborators1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite Collaborators`)
};

/**
* | output |
* | --- |
* | "Invite Collaborators" |
*
* @param {Settings_Collaborators_Invitecollaborators1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaborators1 = /** @type {((inputs?: Settings_Collaborators_Invitecollaborators1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaborators1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaborators1(inputs)
});
export { settings_collaborators_invitecollaborators1 as "settings_collaborators_inviteCollaborators" }